export const Services = {
   "SetAutentication": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": " method for user authentication"
   },
   "AUDIT": {
      "path": "https://rrapiauditoria.azurewebsites.net/",
      "method": "",
      "descrp": "AUDIT"
   }
}